// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__+Klf-","left_box":"style_left_box__5Gc8o","right_box":"style_right_box__bCfc1"};